import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing/landing.component';
import { PerformanceRoutingModule } from './performance.routing.module';
import { PerformanceTestComponent } from './performance-test/performance-test.component';
import { QueueComponent } from './queue/queue.component';
import { SharedModule } from '@app/_shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PerformanceResultsComponent } from './performance-results/performance-results.component';
import { PerformanceLoadTestingComponent } from './performance-load-testing/performance-load-testing.component';
import { MatStepperModule } from '@angular/material/stepper';
import { BusinessFlowFormComponent } from './performance-test/business-flow-form/business-flow-form.component';
import { MetaDataFormComponent } from './performance-test/meta-data-form/meta-data-form.component';
import { ParameterHelpModalComponent } from './performance-test/parameter-help-modal/parameter-help-modal.component';
import { DistributeLoadModalComponent } from './performance-test/distribute-load-modal/distribute-load-modal.component';
import { NgChartjsModule } from 'ng-chartjs';
import { UiSwitchModule } from 'ngx-ui-switch';
import { CompareComponent } from './compare/compare.component';
import { SharedPipeModule } from './../_pipes/shared-pipe.module';
import { CompareResultsComponent } from './compare/compare-results/compare-results.component';
import { SystemStatsComponent } from './performance-results/system-stats/system-stats.component';
import { TestcaseModule } from '@app/testcase/testcase.module';
import { NewPerformanceResultPageComponent } from '@app/new-performance-page/new-performance-result-page/new-performance-result-page.component';
import { NewPerformanceResultSummaryComponent } from '@app/new-performance-page/new-performance-result-summary/new-performance-result-summary.component';
import { NewPerformanceNodeSummaryComponent } from '@app/new-performance-page/new-performance-node-summary/new-performance-node-summary.component';
import { NewSystemStatsComponent } from './performance-results/new-system-stats/new-system-stats.component';
import { NewPerformanceResponseSummaryComponent } from '@app/new-performance-page/new-performance-response-summary/new-performance-response-summary.component';
import { NewPerformanceDetailReportSummaryComponent } from '@app/new-performance-page/new-performance-detail-report-summary/new-performance-detail-report-summary.component';
import { NewPerformanceQueueComponent } from '@app/new-performance-page/new-performance-queue/new-performance-queue.component';
import { NewPerformanceCompareComponent } from '@app/new-performance-page/new-performance-compare/new-performance-compare.component';
import { NewPerformanceJmxUploadComponent } from '@app/new-performance-page/new-performance-jmx-upload/new-performance-jmx-upload.component';

@NgModule({
  declarations: [LandingComponent, PerformanceTestComponent, QueueComponent, PerformanceResultsComponent, PerformanceLoadTestingComponent,
    BusinessFlowFormComponent,
    MetaDataFormComponent,
    ParameterHelpModalComponent,
    CompareComponent,
    CompareResultsComponent,
    SystemStatsComponent,
    DistributeLoadModalComponent,
    NewPerformanceResultPageComponent,
    NewPerformanceResultSummaryComponent,
    NewPerformanceNodeSummaryComponent,
    NewSystemStatsComponent,
    NewPerformanceResponseSummaryComponent,
    NewPerformanceDetailReportSummaryComponent,
    NewPerformanceQueueComponent,
    NewPerformanceCompareComponent,
    NewPerformanceJmxUploadComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    PerformanceRoutingModule,
    MatStepperModule,
    NgChartjsModule,
    SharedPipeModule,
    TestcaseModule,
    UiSwitchModule.forRoot({
      size: 'small'
    })
  ],
  entryComponents: [ParameterHelpModalComponent, DistributeLoadModalComponent]
})
export class PerformanceModule { }
